'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateTeam = exports.joinTeam = exports.createTeam = exports.fetchTeamBySlug = exports.fetchTeam = exports.fetchTeams = exports.deserializeTeam = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _client = require('../../../utils/client');

var client = _interopRequireWildcard(_client);

var _fitness = require('../../../utils/fitness');

var _pages = require('../../pages');

var _params = require('../../../utils/params');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var deserializeTeam = exports.deserializeTeam = function deserializeTeam(team) {
  return {
    active: team.active || team.state === 'active',
    campaign: team.campaign_name,
    campaignId: team.campaign_uid,
    charity: team.charity_name,
    charityId: team.charity_uid,
    id: team.id,
    fitnessDistanceTotal: (0, _fitness.getDistanceTotal)(team),
    fitnessDurationTotal: (0, _fitness.getDurationTotal)(team),
    fitnessGoal: team.fitness_goal,
    image: team.image && team.image.extra_large_image_url,
    leader: team.team_leader_page_uid,
    members: (0, _get2.default)(team, 'members', []).map(function (member) {
      return {
        id: member.id,
        image: (0, _get2.default)(member, 'image.extra_large_image_url'),
        name: member.name,
        raised: (0, _get2.default)(member, 'amount.cents') / 100,
        slug: member.slug,
        status: member.status,
        target: member.target_cents / 100,
        url: member.url,
        userId: member.owner_uid
      };
    }),
    name: team.name,
    owner: team.owner_uid,
    pages: team.team_member_uids,
    raised: (0, _get2.default)(team, 'amount.cents') / 100,
    slug: team.slug,
    story: team.story,
    target: team.target_cents / 100,
    url: team.url,
    uuid: team.uuid
  };
};

var fetchTeams = exports.fetchTeams = function fetchTeams(args) {
  return (0, _pages.fetchPages)(_extends({ type: 'team', allPages: true }, args));
};

var fetchTeam = exports.fetchTeam = function fetchTeam() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  return client.get('api/v2/pages/' + id).then(function (response) {
    return response.page;
  });
};

var fetchTeamBySlug = exports.fetchTeamBySlug = function fetchTeamBySlug() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  return (0, _pages.fetchPage)(params).then(function (data) {
    return (0, _pages.fetchPage)(data.id).then(function (team) {
      return (0, _pages.fetchPages)({ ids: team.team_member_uids, allPages: true }).then(function (members) {
        return _extends({}, team, {
          owner_uid: data.user_id,
          members: members
        });
      });
    });
  });
};

var createTeam = exports.createTeam = function createTeam(_ref) {
  var _ref$token = _ref.token,
      token = _ref$token === undefined ? (0, _params.required)() : _ref$token,
      _ref$page = _ref.page,
      page = _ref$page === undefined ? (0, _params.required)() : _ref$page,
      name = _ref.name;

  var payload = {
    individual_page_id: page,
    name: name
  };

  var options = {
    headers: {
      Authorization: 'Bearer ' + token
    }
  };

  return client.post('api/v2/teams', payload, options).then(function (response) {
    return response.page;
  });
};

var joinTeam = exports.joinTeam = function joinTeam(_ref2) {
  var _ref2$id = _ref2.id,
      id = _ref2$id === undefined ? (0, _params.required)() : _ref2$id,
      _ref2$page = _ref2.page,
      page = _ref2$page === undefined ? (0, _params.required)() : _ref2$page,
      _ref2$token = _ref2.token,
      token = _ref2$token === undefined ? (0, _params.required)() : _ref2$token;

  var payload = {
    individual_page_id: page
  };

  var options = {
    headers: {
      Authorization: 'Bearer ' + token
    }
  };

  return client.post('api/v2/teams/' + id + '/join-requests', payload, options).then(function (response) {
    return response.team;
  });
};

var updateTeam = exports.updateTeam = _pages.updatePage;